import { waLink } from "./data";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const SegmentHero = ({ seg }) => (
  <div className="clip-corner group relative min-h-[320px] overflow-hidden border border-line lg:sticky lg:top-24 lg:self-start">
    <img
      src={seg.img}
      alt={`${seg.title} — Hercules Fitness equipment`}
      className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
      loading="lazy"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/50 to-ink/20" />
    <div className="relative flex h-full flex-col justify-end p-7">
      <h3 className="font-display text-3xl font-extrabold uppercase leading-tight tracking-wide text-white">
        {seg.title}
      </h3>
      <p className="mt-3 text-sm leading-relaxed text-white/75">{seg.tagline}</p>
      <a
        href={waLink(
          `Hi Lift Edge team, I'm interested in the Hercules Fitness ${seg.title} range. Please share details and availability.`
        )}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`product-enquire-${seg.key}`}
        className="clip-corner-sm mt-6 inline-flex w-fit items-center gap-2 bg-edge px-5 py-2.5 font-display text-sm font-bold uppercase tracking-wider text-white transition-colors duration-200 hover:bg-edgehot"
      >
        <WhatsAppIcon className="h-4 w-4" />
        Enquire Now
      </a>
    </div>
  </div>
);

export const CatalogueGroups = ({ seg }) => (
  <div className="space-y-px border border-line bg-line">
    {seg.groups.map((g) => (
      <div key={g.name} className="bg-coal p-7">
        <p className="mb-5 flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.28em] text-edge">
          <span className="inline-block h-px w-6 bg-edge" aria-hidden="true" />
          {g.name}
        </p>
        <ul className="flex flex-wrap gap-2">
          {g.items.map((item) => (
            <li key={item}>
              <a
                href={waLink(
                  `Hi Lift Edge team, I'm interested in Hercules Fitness — ${item} (${seg.title}). I'm planning within a budget, please suggest the best options.`
                )}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`product-chip-${item.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="block border border-line px-3.5 py-2 font-mono text-[10px] uppercase tracking-[0.15em] text-ash transition-colors duration-200 hover:border-edge hover:bg-edge hover:text-white"
                title={`Enquire about ${item}`}
              >
                {item}
              </a>
            </li>
          ))}
        </ul>
      </div>
    ))}
    <p className="bg-coal px-7 py-4 font-mono text-[10px] uppercase tracking-[0.2em] text-dim">
      Tap any product to enquire on WhatsApp — share your budget and we&rsquo;ll build your gym around it
    </p>
  </div>
);
